import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'unh-banner-birthday',
  templateUrl: './banner-birthday.component.html',
  styleUrls: ['./banner-birthday.component.scss'],
})
export class BannerBirthdayComponent implements OnInit {
  countdown: string = '';
  private intervalId: any;
  private remainingSeconds: number;

  ngOnInit() {
    const agora = Date.now();
    const horaFim = new Date('2025-11-28T22:00:00').getTime();
    const diff = Math.floor((horaFim - agora) / 1000);
    this.remainingSeconds = diff;

    if (diff > 0) {
      this.updateCountdown();
      this.intervalId = setInterval(() => {
        this.remainingSeconds--;
        this.updateCountdown();
        if (this.remainingSeconds <= 0) {
          clearInterval(this.intervalId);
        }
      }, 1000);
    } else {
      this.countdown = '00:00:00 horas';
    }
  }

  updateCountdown() {
    const dias = Math.floor(this.remainingSeconds / 86400);
    const horas = Math.floor((this.remainingSeconds % 86400) / 3600);
    const minutos = Math.floor((this.remainingSeconds % 3600) / 60);
    const segundos = this.remainingSeconds % 60;

    const pad = (n: number) => String(n).padStart(2, '0');
    this.countdown = `${dias ? dias + ' dias e' : ''} ${pad(horas)}:${pad(
      minutos
    )}:${pad(segundos)} horas`;
  }
}
